import { RuleType } from "layouts/charging-rules/interface/Rules.ts"

const getDataCyValue = (ruleType: RuleType): string => {
    const dataCyMap: Record<RuleType, string> = {
        [RuleType.DOWBlocked]: "unauthorized-days",
        [RuleType.HoursBlocked]: "restriction-hours",
        [RuleType.MaxRechargeDurationOptions]: "max-duration",
        [RuleType.MaxRechargeEnergyOptions]: "max-energy",
    }
    return dataCyMap[ruleType] || ""
}

export const DataCySelectValue = (ruleType: RuleType): string =>
    `side-bar__nav-charging-rules--${getDataCyValue(ruleType)}`

export const DataCySelectOption = (ruleType: RuleType): string =>
    `nav-charging-rules__${getDataCyValue(ruleType)}`

export const GRID_SIZES = {
    TITLE: { xs: 12, sm: 12, md: 2, lg: 2, xl: 1.5 },
    SELECT: { xs: 12, sm: 12, md: 3, lg: 3, xl: 2 },
    CONTENT: { xs: 12, sm:12 , md: 7, lg: 7,  xl: 8.5 },
}

export const ruleTitlesTranslation = {
    fr: {
        [RuleType.DOWBlocked]: "Jours non autorisés",
        [RuleType.HoursBlocked]: "Heures non autorisées",
        [RuleType.MaxRechargeDurationOptions]: "Durée max recharge",
        [RuleType.MaxRechargeEnergyOptions]: "Énergie max recharge",
    },
    en: {
        [RuleType.DOWBlocked]: "Unauthorized days",
        [RuleType.HoursBlocked]: "Unauthorized hours",
        [RuleType.MaxRechargeDurationOptions]: "Max recharge duration",
        [RuleType.MaxRechargeEnergyOptions]: "Max recharge energy",
    },
}